// extracted by mini-css-extract-plugin
export var pillWrapper = "_i3-0";
export var showOverflow = "_i3-1";